import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'logoUrl',
    standalone: false
})
export class LogoUrlPipe implements PipeTransform {
    transform(logoUrl: string, primaryDomain: string): string {
        return logoUrl && logoUrl.indexOf('https') > -1
            ? logoUrl
            : 'https://logo.clearbit.com/' + primaryDomain;
    }
}
